module.exports = __webpack_public_path__ + "static/media/CNSA-MAIA-Case-Manager-Training.205b9683.jpg";